import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PhxImagePanZoomComponent } from './phx-image-pan-zoom.component';

@NgModule({
  declarations: [PhxImagePanZoomComponent],
  imports: [CommonModule],
  exports: [PhxImagePanZoomComponent]
})
export class PhxImagePanZoomModule { }